import React from 'react';

export const PrivacyPolicyContainer = ({ children }: { children: JSX.Element }) => {
  return (
    <div>
      <div className="mx-4 pb-20 pt-16 md:mx-24">{children}</div>
    </div>
  );
};
